























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Flow extends Vue {
  @Prop() private msg!: string;

  userFlow = [
    {
      image: 'icon_search.png',
      text: '透過INCADD Website開始 查看符合您條件的海外新創 企業',
    },
    {
      image: 'icon_send.png',
      text: '填寫進一步商談意願的表單 ，INCADD Website從旁協 助雙方開始交流',
    },
    {
      image: 'icon_contact.png',
      text: '順利完成雙方媒合！另外留 下您的需求，將能第一時間 收到新創情報！',
    },
    {
      image: 'icon_.png',
      text: '媒合過程中有任何交流上的 問題或需求，INCADD都能 從旁協助消弭。',
    },
  ]
}
